import {ILeadModalLeadType} from "../../../../lead/types/ILeadModalLeadType";

export const getGtmEcommerceOfferEventCategoryByLeadType = (leadType: ILeadModalLeadType) => {
    if (leadType === "conversation") {
        return "conversation_form";
    }
    if (leadType === "simple") {
        return "simple_form";
    }
    return "standard";
};
import {ILeadModalLeadType} from "../../../../lead/types/ILeadModalLeadType";

export const getGtmEcommerceOfferEventCategoryByLeadType = (leadType: ILeadModalLeadType) => {
    if (leadType === "conversation") {
        return "conversation_form";
    }
    if (leadType === "simple") {
        return "simple_form";
    }
    return "standard";
};
